/* Build in libraries */

/* Third party libraries */
import { PlusIcon } from '@heroicons/react/24/solid';
import { useState } from 'react';
import { useParams } from 'react-router';
import { Layout } from '@/components/Layout';
import { LayoutCard, LayoutCardContent, LayoutCardTitle } from '@/components/LayoutCard';
import { HasPermission } from '@/components/Permission/HasPermission';
/* Components */
import Button from '@/components/UI/Button';
import { useProject, useProjectTeamMembers } from '@/hooks/ReactQueryHooks/useProjectQuery';
/* Services */
import { usePermission } from '@/hooks/usePermission';
import { DrawList } from '../DrawList';
import { NewDraw } from '../NewDraw';

const DrawSummary = () => {
  const { projectId } = useParams();
  const [showModal, setShowModal] = useState({
    newDraw: false,
  });

  const { hasPermission } = usePermission();

  const handleModal = () => {
    setShowModal((prevState) => ({
      ...prevState,
      newDraw: !prevState.newDraw,
    }));
  };

  const fetchProject = useProject({ projectId: Number(projectId) });
  const project = fetchProject?.data?.data;

  const getProjectTeamMembers = useProjectTeamMembers({
    projectId: Number(projectId),
  });
  const projectTeamMembers = getProjectTeamMembers?.data?.data;

  const addNewDrawBtn = (
    <>
      <Button label='New Draw' icon={<PlusIcon className='h-5 w-5' />} btnStyle='btn-primary' type='button' onClick={handleModal} />
    </>
  );

  return (
    <>
      <Layout>
        <LayoutCard>
          <LayoutCardTitle title='Draws' actions={hasPermission(['ADD_PROJECT_DRAW']) && addNewDrawBtn} />
          <LayoutCardContent>
            <HasPermission of={'LIST_PROJECT_DRAWS'}>
              <DrawList teams={projectTeamMembers} />
            </HasPermission>
          </LayoutCardContent>
        </LayoutCard>
      </Layout>
      {showModal.newDraw && <NewDraw handleModal={handleModal} teams={projectTeamMembers} projectName={project?.name || ''} />}
    </>
  );
};

export default DrawSummary;
